module.exports = __webpack_public_path__ + "img/location.e4ca1087.png";